import {QueryKey, useQuery, UseQueryOptions} from '@tanstack/react-query';
import {getSuggestions} from 'api/requests';
import {IKeyWordsList} from 'types';

export const useSuggestions = (queryKey: QueryKey, options: UseQueryOptions<IKeyWordsList>, locale: string) => {
  return useQuery<IKeyWordsList>({
    queryKey,
    queryFn: () => getSuggestions(locale),
    ...options,
  });
};
